import axios from "axios";

const StrapiServices = {
  getCategories: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/strapi-category`
    );
    return response;
  },
};

export default StrapiServices;
